'use client';
import { useState } from 'react';
import { randomId, isString } from '@s7/utils';
import { useReactId } from './useReactId.js';
import { useIsomorphicEffect } from '../useIsomorphicEffect/useIsomorphicEffect.js';

var useId = function(staticId) {
    var reactId = useReactId();
    var _useState = useState(reactId), uuid = _useState[0], setUuid = _useState[1];
    useIsomorphicEffect(function() {
        setUuid(randomId());
    }, []);
    if (isString(staticId)) {
        return staticId;
    }
    if (typeof window === "undefined") {
        return reactId;
    }
    return uuid;
};

export { useId };
